export default __webpack_public_path__ + "static/media/D1.5ab34f1a.svg";